const MAX_DETAIL_LENGTH = 30;

export default {
  data() {
    return {
      isLoad: false,
      open: false,
      Dialog: {
        VideoID: "",
        Title: ""
      }
    };
  },
  computed: {
    isList() {
      return this.$store.getters.listState;
    }
  },
  methods: {
    load: function() {
      this.isLoad = true;
    },
    openDialog: function(movie) {
      this.open = true;
      this.Dialog.Title = movie.title;
      this.Dialog.VideoID = `https://www.youtube.com/embed/${movie.id}?autoplay=1`;
    },
    // ロジック内で整形する必要があるものはこちらを使用
    truncate: function(value) {
      if (value === null) {
        return "";
      }
      if (value.length <= MAX_DETAIL_LENGTH) {
        return value;
      }
      return value.substr(0, MAX_DETAIL_LENGTH) + "...";
    },
    // 2重で取得されるものをフィルタリング
    filterDuplicate: function(data) {
      return data.filter((v, i, a) => {
        return (
          a.findIndex(v2 => {
            return v.id === v2.id;
          }) === i
        );
      });
    }
  },
  filters: {
    truncate: function(value) {
      if (value === null) {
        return "";
      }
      if (value.length <= MAX_DETAIL_LENGTH) {
        return value;
      }
      return value.substr(0, MAX_DETAIL_LENGTH) + "...";
    },
    dispDate: function(value) {
      const date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      return `${year}年${month}月${day}日 ${hour}時${min}分`;
    }
  },
  watch: {
    open: function(value) {
      if (!value) {
        this.Dialog.VideoID = "";
        this.Dialog.Title = "";
      }
    }
  }
};
